import React from 'react';

// HoC
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

// Actions
import { logout } from 'common/store/actions/authenticate';

// Utitities
import classNames from 'classnames';
import history from 'common/constants/config/history';
import getSSOUrl from 'common/constants/config/ssoUrl';

// Components
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

// Icons
import IdentificationDocumentsIcon from 'common/icons/IdentificationDocuments';

const ACCEPTABLE_DOCS_URL =
  'https://www.uscis.gov/i-9-central/acceptable-documents/list-documents/form-i-9-acceptable-documents';

const MYCNC_W4S_URL = `${getSSOUrl()}/w4s`;

const styles = {
  root: {
    display: 'grid',
    height: '100%',
    width: '100%',
    placeItems: 'center',
    gridTemplateColumns: 'auto 320px auto',
    gridTemplateRows: '15% 440px auto',
    gridTemplateAreas: `
    ". ....... ."
    ". content ."
    ". ....... ."`,
  },
  content: {
    gridArea: 'content',
    display: 'grid',
    height: '100%',
    width: '100%',
    gridTemplateColumns: '5% 40% 10% 40% 5%',
    gridTemplateRows: '20px 40px 140px 90px 30px 40px 20px 20px',
    gridTemplateAreas: `
    ". ............ ............ ............ ."
    ". headerText   headerText   headerText   ."
    ". image        image        image        ."
    ". footerText   footerText   footerText   ."
    ". ............ ............ ............ ."
    ". statusButton ............ myCnCButton  ."
    ". ............ ............ ............ ."
    ". ............ logoutButton ............ ."
    ". ............ ............ ............ ."`,
  },
  headerText: {
    gridArea: 'headerText',
    placeSelf: 'center',
    color: '#5a6062',
  },
  image: {
    gridArea: 'image',
    placeSelf: 'center',
    height: 'auto',
    width: '100%',
    maxHeight: '100%',
  },
  footerText: {
    gridArea: 'footerText',
    placeSelf: 'center',
    color: '#5a6062',
  },
  statusButton: {
    gridArea: 'statusButton',
    placeSelf: 'center',
  },
  myCnCButton: {
    gridArea: 'myCnCButton',
    placeSelf: 'center',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  logoutButton: {
    gridArea: 'logoutButton',
    placeSelf: 'center',
  },
  i9Link: {
    color: '#4eaffc',
    fontWeight: 'bold',
  },
};

const OnboardingComplete = props => {
  const { match = {}, logout, classes } = props;
  const { params = {} } = match || {};
  const { offerId } = params;

  const goToSubmittedOffer = () =>
    history.push(`/onboarding/offers/${offerId}/submitted`);
  return (
    <div className={classes.root} elevation={4}>
      <Paper className={classes.content}>
        <Typography variant="h6" align="center" className={classes.headerText}>
          Your Start Packet has been Submitted for Approval!
        </Typography>
        <IdentificationDocumentsIcon className={classes.image} />
        <Typography variant="h6" align="center" className={classes.footerText}>
          {`Don’t forget your I-9 needs to be verified, so bring `}
          <Link
            href={ACCEPTABLE_DOCS_URL}
            target="_blank"
            rel="noopener"
            className={classes.i9Link}
            data-test-id="Complete-i9AcceptableDocsLink"
          >
            acceptable documents
          </Link>
          {` within 3 days of when you report to work. Go to MyCast&Crew to fill out your Federal and State W-4s.`}
        </Typography>
        <Button
          variant="contained"
          onClick={goToSubmittedOffer}
          className={classNames(classes.button, classes.statusButton)}
        >
          Offer Status
        </Button>
        <Link href={MYCNC_W4S_URL} className={classes.myCnCButton}>
          <Button variant="contained" className={classes.button}>
            Go to My W-4s
          </Button>
        </Link>
        <Button
          variant="contained"
          onClick={logout}
          className={classNames(classes.button, classes.logoutButton)}
        >
          Logout
        </Button>
      </Paper>
    </div>
  );
};
const mapStateToProps = () => {};
const mapDispatchToProps = {
  logout,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withRouter,
  withStyles(styles),
)(OnboardingComplete);
